import Footer from '../Layout/Footer'
import AppShowCase from '../shared/AppShowCase/AppShowCase'
import BannerSlide from '../shared/BannerSlider/BannerSlide'
import ContactUsBanner from '../shared/ContactusBanner'
import DownloadAppBanner from '../shared/DownloadAppBanner'
import Faq from '../shared/Faq'
import FeaturedCard from '../shared/FeaturedCard/FeaturedCard'
import UniveralBanner from '../shared/UniversalBanner'
import Features from './Features'
import { useSeoData } from '../hook/useSeoData'
import { useFaqData } from '../hook/useFaqData'
import SeoHead from '../shared/SeoHead/SeoHead'

const HomePage = () => {
  const seo = useSeoData('home-seo', 'homeSeo')
  const faq = useFaqData('Company')
  return (
    <>
      <SeoHead seo={seo} />
      <BannerSlide />
      <FeaturedCard />
      <AppShowCase />
      <Features />
      <UniveralBanner />
      <Faq faqData={faq} />
      <ContactUsBanner />
      <DownloadAppBanner />
      <Footer />
    </>
  )
}

export default HomePage
